import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import { AnnotationView } from "@/entities/annotation";
import { JourneyAnnotationForm } from "../journey/journey-annotation-form";
import TransactionAnnotationForm from "../transaction/transaction-annotation-form";
import TrackPersistenceAnnotationForm from "../track-persistence/track-persistence-annotation-form";
import ProximityAnnotationForm from "../proximity/proximity-annotation-form";
import ProximityTimeRangesAnnotationForm from "../proximity-time-range/proximity-time-range-annotation-form";

const annotationForms: Record<AnnotationView, React.FC> = {
  [ANNOTATION_TYPES.JOURNEY]: JourneyAnnotationForm,
  [ANNOTATION_TYPES.TRANSACTION]: TransactionAnnotationForm,
  [ANNOTATION_TYPES.TRACK_PERSISTENCE]: TrackPersistenceAnnotationForm,
  [ANNOTATION_TYPES.PROXIMITY]: ProximityAnnotationForm,
  [ANNOTATION_TYPES.PROXIMITY_TIME_RANGES]: ProximityTimeRangesAnnotationForm,
};

export const getAnnotationForm = (type: AnnotationView) => {
  return annotationForms[type];
};
